export const Scallop = ({ bg = "#FFFFFF", color = "#4A148C" }) => (
  <div
    aria-hidden="true"
    className="w-full h-4"
    style={{
      backgroundColor: bg,
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='16'%3E%3Cpath d='M0 16 A14 14 0 0 1 28 16 Z' fill='${color.replace("#", "%23")}'/%3E%3C/svg%3E")`,
      backgroundRepeat: "repeat-x",
      backgroundPosition: "bottom",
      backgroundSize: "28px 16px",
    }}
    data-testid="scallop-divider"
  />
);
